import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\WikiContact\GetWikiContactListForACityController::__invoke
* @see app/Http/Controllers/WikiContact/GetWikiContactListForACityController.php
* @route '/api/wiki-contact/for-city/{city}'
*/
const GetWikiContactListForACityController = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiContactListForACityController.url(args, options),
    method: 'get',
})

GetWikiContactListForACityController.definition = {
    methods: ["get","head"],
    url: '/api/wiki-contact/for-city/{city}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\WikiContact\GetWikiContactListForACityController::__invoke
* @see app/Http/Controllers/WikiContact/GetWikiContactListForACityController.php
* @route '/api/wiki-contact/for-city/{city}'
*/
GetWikiContactListForACityController.url = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { city: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { city: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            city: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        city: typeof args.city === 'object'
        ? args.city.id
        : args.city,
    }

    return GetWikiContactListForACityController.definition.url
            .replace('{city}', parsedArgs.city.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\WikiContact\GetWikiContactListForACityController::__invoke
* @see app/Http/Controllers/WikiContact/GetWikiContactListForACityController.php
* @route '/api/wiki-contact/for-city/{city}'
*/
GetWikiContactListForACityController.get = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetWikiContactListForACityController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\WikiContact\GetWikiContactListForACityController::__invoke
* @see app/Http/Controllers/WikiContact/GetWikiContactListForACityController.php
* @route '/api/wiki-contact/for-city/{city}'
*/
GetWikiContactListForACityController.head = (args: { city: number | { id: number } } | [city: number | { id: number } ] | number | { id: number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetWikiContactListForACityController.url(args, options),
    method: 'head',
})

export default GetWikiContactListForACityController